<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.9619 2.5C15.6349 2.5002 19.4229 6.28886 19.4229 10.9619C19.4228 13.0211 18.6864 14.9092 17.4639 16.376L22.2744 21.1865C22.5748 21.4869 22.5748 21.974 22.2744 22.2744C21.974 22.5748 21.4869 22.5748 21.1865 22.2744L16.376 17.4639C14.9092 18.6864 13.0211 19.4228 10.9619 19.4229C6.28886 19.4229 2.5002 15.6349 2.5 10.9619C2.5 6.28874 6.28874 2.5 10.9619 2.5ZM10.6943 12.416C8.39864 12.4161 6.53759 14.0436 6.2793 16.0596C7.51209 17.1923 9.15592 17.8848 10.9619 17.8848C12.5569 17.8847 14.0228 17.3431 15.1934 16.4365C15.0362 15.5133 14.5547 14.5936 13.8447 13.8594C12.9885 12.9739 11.8596 12.4161 10.6943 12.416ZM10.9619 4.03809C7.1384 4.03809 4.03809 7.1384 4.03809 10.9619C4.03816 12.314 4.42733 13.5747 5.09766 14.6406C5.74502 12.942 7.2329 11.64 9.0459 11.1396C7.92158 10.5757 7.13585 9.451 7.13574 8.11816C7.13593 6.19711 8.76804 4.70809 10.6943 4.70801C12.6205 4.70821 14.2518 6.19719 14.252 8.11816C14.2518 9.47127 13.4418 10.6089 12.29 11.1641C13.2996 11.4793 14.2039 12.073 14.9229 12.8164C15.5809 13.4969 16.1045 14.3238 16.4199 15.2158C17.3368 14.0416 17.8847 12.5669 17.8848 10.9619C17.8848 7.13853 14.7853 4.03829 10.9619 4.03809ZM10.6943 6.20801C9.51902 6.20809 8.63593 7.10092 8.63574 8.11816C8.6359 9.13543 9.51899 10.0292 10.6943 10.0293C11.8696 10.0291 12.7518 9.13537 12.752 8.11816C12.7518 7.10099 11.8695 6.20821 10.6943 6.20801Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgLookupPeople',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
